import { render, staticRenderFns } from "./CoreSurvey.vue?vue&type=template&id=4dd6721e&"
import script from "./CoreSurvey.vue?vue&type=script&lang=js&"
export * from "./CoreSurvey.vue?vue&type=script&lang=js&"
import style0 from "./CoreSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports